export const NoOrganization = () => (<>
    <div>Invalid organization access</div>
</>)